import { ControlLink } from '@moda/om';
import classNames from 'classnames';
import React, { useState } from 'react';
import { Image, ImageProps } from '../../../Image';
import {
  VisualStyleFilterShapeLayout,
  VisualStyleFilterShapeLayoutProps
} from '../VisualStyleFilterShapeLayout';

import './VisualStyleFilter.scss';

interface Props {
  children:
    | React.ReactElement<ImageProps, typeof Image>
    | React.ReactElement<VisualStyleFilterShapeLayoutProps, typeof VisualStyleFilterShapeLayout>;
  isSelected: boolean;
  onClick: () => void;
  name: string | null;
}

export const VisualStyleFilter: React.FC<Props> = ({ children, isSelected, name, onClick }) => {
  const [isHovered, setHovered] = useState(false);
  const [isFocused, setFocused] = useState(false);

  return (
    <div
      className="VisualStyleFilter"
      onClick={onClick}
      onKeyPress={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      role="button"
      tabIndex={0}
    >
      {React.Children.map(
        children,
        child =>
          React.isValidElement<ImageProps>(child) &&
          React.cloneElement(child, {
            className: classNames(child.props.className, {
              'VisualStyleFilter__image--focused': isFocused && child.type === Image,
              'VisualStyleFilter__svg--focused':
                isFocused && child.type === VisualStyleFilterShapeLayout
            })
          })
      )}

      {name && (
        <ControlLink
          className="VisualStyleFilter__description"
          tabIndex={-1}
          underlined={isHovered || isSelected || isFocused}
        >
          {name}
        </ControlLink>
      )}
    </div>
  );
};
